var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link",attrs:{"href":_vm.url,"target":"_blank"}},[(_vm.isNew)?_c('span',{staticClass:"badge badge-success"},[_vm._v("New!")]):_vm._e(),_c('span',{class:_vm.newClass},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }